import { styleConstants } from '@paywithextend/components'
import React from 'react'
import SvgDeactivatedUserAvatar from 'src/components/Svgs/SvgDeactivatedUserAvatar'
import TextAvatar from 'src/components/TextAvatar/TextAvatar'
import { AvatarSizes } from 'src/enums'
import { UserListModel } from 'src/models/user.models'
import { css } from 'styled-components'

interface UserAvatarProps {
  className?: string
  size: AvatarSizes
  user:
    | UserListModel
    | {
        id: string
        fullNameOrEmail: string
        initials: string
        avatarUrl?: string
        deactivated?: boolean
      }
  subIcon?: React.ReactElement
  subIconId?: string
  // Hide the avatar from assistive tech when an adjacent label already names the
  // user (e.g. a linked name in the same cell), so screen readers don't announce
  // the name twice.
  decorative?: boolean
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  className,
  size,
  user,
  subIcon,
  subIconId,
  decorative,
}): React.ReactElement => {
  let sizeStyling = css``
  let svgSize = 0
  switch (size) {
    case AvatarSizes.Small:
      sizeStyling = css`
        width: 22px;
        height: 22px;
      `
      svgSize = 22
      break
    case AvatarSizes.Small24:
      sizeStyling = css`
        width: 24px;
        height: 24px;
      `
      svgSize = 24
      break
    case AvatarSizes.Medium:
      sizeStyling = css`
        width: 32px;
        height: 32px;
      `
      svgSize = 32
      break
    case AvatarSizes.MediumLarge:
      sizeStyling = css`
        width: 36px;
        height: 36px;
      `
      svgSize = 36
      break
    case AvatarSizes.Large:
      sizeStyling = css`
        width: 40px;
        height: 40px;
      `
      svgSize = 40
      break
    case AvatarSizes.Huge:
      sizeStyling = css`
        width: 60px;
        height: 60px;
      `
      svgSize = 60
      break
    case AvatarSizes.ExtraHuge:
      sizeStyling = css`
        width: 100px;
        height: 100px;
      `
      svgSize = 100
      break
    case AvatarSizes.ExtraExtraHuge:
      sizeStyling = css`
        width: 140px;
        height: 140px;
      `
      svgSize = 140
      break
  }

  return (
    <div
      className={className}
      css={sizeStyling}
      aria-hidden={decorative || undefined}
    >
      {!user?.deactivated ? (
        <>
          {user?.avatarUrl !== undefined && user?.avatarUrl !== null ? (
            <img
              css={css`
                border-radius: 50%;
                ${sizeStyling}
              `}
              src={user?.avatarUrl}
              alt={user?.fullNameOrEmail}
            />
          ) : (
            <TextAvatar id={subIconId} size={size} text={user?.initials} />
          )}
          {subIcon && (
            <TextAvatar
              size={AvatarSizes.Small}
              defaultIcon={subIcon}
              css={css`
                position: absolute;
                bottom: -6px;
                right: -6px;
              `}
            />
          )}
        </>
      ) : (
        <div
          css={css`
            ${sizeStyling}
            border-radius: 50%;
            background-color: ${styleConstants.colors.white};
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.15);
          `}
        >
          <SvgDeactivatedUserAvatar
            css={css`
              overflow: visible;
              transform: scale(calc(${svgSize} / 30));
            `}
          />
        </div>
      )}
    </div>
  )
}

export default UserAvatar
